import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { useHistory } from "react-router";
import { withTranslation } from "react-i18next";
import * as rk from "../../../localization/resourceKeys";
import i18n from "../../../i18n";
import { loadRequestSelectorSuccess } from "../../../redux/RequestSelector/requestSelectorActions";
import RedirectModal from "../../RedirectModal/RedirectModal";
import "./rightRow.css";
import PropTypes from "prop-types";
import { specialPolicyStates, virginiaLikeStates } from "../../../utils/statesUS";
import tippy from "tippy.js";

const RightRow = ({
  type,
  rightTitle,
  rightTitleKey,
  rightText,
  image,
  loadRequestSelectorSuccess,
  country,
  stateSelector,
  dataTestId,
  requestForm,
  disabled,
  showInfo,
}) => {
  const history = useHistory();
  const [isSecureKeyModalOpen, setIsSecureKeyModalOpen] = useState(false);

  const setRequestType = (type) => {
    const value = {
      selectedRequest: type,
    };
    loadRequestSelectorSuccess(value);
    if (stateSelector.selectedFlow === "check") {
      if (
        stateSelector.customerRelation === i18n.t(rk.QUESTION_2_OPTION_2) &&
        type === "Correct My Personal Information"
      ) {
        return history.push({ pathname: "/RightToCorrectPersonnel" });
      } else return history.push({ pathname: "/verificationForm" });
    } else {
      if (country.toLowerCase() === "canada") {
        if (type === "Know My Personal Information") {
          return setIsSecureKeyModalOpen(true);
        }
        if (type === "Correct My Personal Information") {
          return history.push({ pathname: "/dataCorrectionVCI" });
        }
        if (type === "Withdraw") {
          return history.push({ pathname: "/withdraw" });
        }
      }
      if (type === "Correct My Personal Information") {
        if (virginiaLikeStates.includes(stateSelector.currentStateResidence)) {
          return history.push({ pathname: "/mailingAddress" });
        }
        if (stateSelector.customerRelation === i18n.t(rk.QUESTION_2_OPTION_2)) {
          return history.push({ pathname: "/RightToCorrectPersonnel" });
        }
        if (
          requestForm.step?.brand === i18n.t(rk.BRANDS_OPTION_VWD_APP_DER) &&
          specialPolicyStates.includes(stateSelector.currentStateResidence)
        ) {
          return history.push({ pathname: "/mailingAddress" });
        } else return history.push({ pathname: "/dataCorrectionUserType" }); //Landing page with the options of VCI and Volkswagen  user
      } else {
        return history.push({ pathname: "/mailingAddress" });
      }
    }
  };

  useEffect(() => {
    // Enable tooltip.
    tippy(document.querySelectorAll(`.js-tooltip`), {
      arrow: true,
      theme: 'custom-center',
    });
  });

  const acomodateText = () => {
    return rightText?.map((sentence) => {
      sentence = i18n.t(sentence);
      return sentence.includes("•") ? (
        <div className="right-text-list">
          <p key={sentence}>{sentence}</p>
        </div>
      ) : (
        <p key={sentence}>{sentence}</p>
      );
    });
  };

  const handleMouseEnter = (type) => {
    const selectRequestBtn = document.getElementById(
      `select-request-btn_${type}`
    );
    selectRequestBtn.classList.add("right-row_btn_focus");
  };

  const handleMouseLeave = (type) => {
    const selectRequestBtn = document.getElementById(
      `select-request-btn_${type}`
    );
    selectRequestBtn.classList.remove("right-row_btn_focus");
  };

  const handleOnClickToggle = (type) => {
    const rightRowGrid = document.getElementById(`rightRowGrid_${type}`);
    rightRowGrid.classList.toggle("right-row_content_descrition");

    const descriptionDiv = document.getElementById(
      `right-row-description_${type}`
    );
    descriptionDiv.classList.toggle("right-row_description-show");

    const requestDescriptionIcon = document.getElementById(
      `request-description-icon_${type}`
    );
    requestDescriptionIcon.classList.toggle("up-icon");
  };

  return (
    <div
      className={`right-row ${disabled ? "disabled" : ""}`}
      data-testid={`right-row_${dataTestId}`}
    >
      <div className="right-row_wrapper">
        <div id={`rightRowGrid_${type}`} className="right-row_content">
          <div className="right-row_content_left">
            <div className="right-row_img">
              <img src={image} alt="placeholder72px" />
            </div>
            <div className="right-row_info">
              <div className="right-row_title">
                <span>
                  {rightTitleKey ? i18n.t(rightTitleKey) : rightTitle}
                  {showInfo && (
                    <button
                      type="button"
                      className="c-icon c-info-icon  js-tooltip  c-icon--[semantic-info] c-icon--xxsmall u-ml-xsmall info-disabled js-tooltip"
                      aria-label="Tooltip"
                      data-tippy-content={i18n.t(rk.AGENT_SUBMIT.TooltipContent)}
                      data-tippy-placement="bottom"
                    ></button>
                  )}
                </span>
              </div>
              <div
                className="request-description-btn"
                onClick={() => handleOnClickToggle(type)}
                data-testid={`request-description-btn_${dataTestId}`}
              >
                <p>{i18n.t(rk.REQUEST_SELECTOR.TEXT_REQUEST_DESCRIPTION)}</p>
                <div className="request-description-btn_icon">
                  <i
                    id={`request-description-icon_${type}`}
                    className="c-btn__icon  c-icon  c-icon--[semantic-forward] down-icon"
                    aria-hidden="true"
                    role="img"
                  ></i>
                </div>
              </div>
            </div>
          </div>
          <div className="right-row_content_right">
            <div className="right-row_cta">
              <button
                id={`select-request-btn_${type}`}
                data-testid={`select-request-btn_${dataTestId}`}
                className="right-row_btn c-btn"
                onClick={() => disabled ? false : setRequestType(type)}
                onMouseEnter={() => handleMouseEnter(type)}
                onMouseLeave={() => handleMouseLeave(type)}
              >
                <span className="c-btn__text">
                  {i18n.t(rk.REQUEST_SELECTOR.TEXT_SELECT_THIS_REQUEST)}
                </span>
              </button>
            </div>
          </div>
          <div
            id={`right-row-description_${type}`}
            className="right-row_description"
          >
            <div className="right-row_description_title">
              {rightTitleKey ? i18n.t(rightTitleKey) : rightTitle}
            </div>

            <div className="right-row_description_text">{acomodateText()}</div>
          </div>
        </div>
      </div>
      <RedirectModal
        isModalOpen={isSecureKeyModalOpen}
        setIsModalOpen={setIsSecureKeyModalOpen}
        id={type}
      />
    </div>
  );
};

RightRow.propTypes = {
  type: PropTypes.string.isRequired,
  rightTitle: PropTypes.string,
  rightTitleKey: PropTypes.string,
  rightText: PropTypes.array,
  image: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  showInfo: PropTypes.bool,
  loadRequestSelectorSuccess: PropTypes.func.isRequired,
  country: PropTypes.string.isRequired,
  stateSelector: {
    selectedFlow: PropTypes.string,
    customerRelation: PropTypes.string,
    currentStateResidence: PropTypes.string,
  },
  dataTestId: PropTypes.string.isRequired,
  requestForm: {
    step: {
      customerRelation: PropTypes.string,
      supportedState: PropTypes.string,
      brand: PropTypes.string,
    },
  },
};

RightRow.defaultProps = {
  disabled: false,
  showInfo: false,
};

const mapStateToProps = (state) => {
  return {
    country: state.initialReducer.country,
    stateSelector: state.stateSelector,
    selectedRequest: state.requestSelector.selectedRequest,
    requestForm: state.requestForm,
  };
};

const mapDispatchToProps = (dispatch) => ({
  loadRequestSelectorSuccess: (value) =>
    dispatch(loadRequestSelectorSuccess(value)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation()(RightRow));
